// extracted by mini-css-extract-plugin
export default {"social":"Social_social__ex2Tn","icon":"Social_icon__2dy50","link":"Social_link__SeQRi"};